module.exports = __webpack_public_path__ + "direction_ru.png?5cd2851ef2f964d5e6515ba2578a1331";


//////////////////
// WEBPACK FOOTER
// ./src/assets/direction_ru.png
// module id = 241
// module chunks = 0